import { Prompt, PromptUpdate } from '@/types';
import { httpService } from '@/utils/httpService';

async function getPrompts(): Promise<Prompt[]> {
  return httpService.get<Prompt[]>('/prompts/');
}

async function updatePrompt(
  promptId: string,
  payload: PromptUpdate
): Promise<Prompt> {
  return httpService.patch<Prompt>(`/prompts/${promptId}`, payload);
}

async function resetPrompt(promptId: string): Promise<Prompt> {
  return httpService.post<Prompt>(`/prompts/${promptId}/reset`);
}

export const promptService = {
  getPrompts,
  updatePrompt,
  resetPrompt,
} as const;
